export const CREATE_TENANT = (gql: any) => gql`
    mutation createTenant($data: CreateTenantInput!) {
        createTenant(data: $data) {
            id
            code
        }
    }
`;
export const DELETE_TENANT = (gql: any) => gql`
    mutation deleteTenant($id: ID!) {
        deleteTenant(id: $id) {
            id
        }
    }
`;
export const FIND_TENANTS = (gql: any) => gql`
    query findTenants($offset: String, $limit: Int) {
        findTenants(offset: $offset, limit: $limit) {
            cursor
            count
            items {
                id
                code
                name
                publicPageShortUrl
            }
        }
    }
`;
export const GET_TENANT = (gql: any) => gql`
    query getTenant($id: ID!) {
        getTenant(id: $id) {
            id
            code
            name
        }
    }
`;
export const UPDATE_TENANT = (gql: any) => gql`
    mutation updateTenant($id: ID!, $data: UpdateTenantInput!) {
        updateTenant(id: $id, data: $data) {
            id
        }
    }
`;